import { FIN_OCC_CARDS_ITEM } from './fin-occ-cards.js'
import { FIN_OCC_MOVEMENTS_ITEM } from './fin-occ-movements.js'
import { FIN_OCC_STATEMENTS_ITEM } from './fin-occ-statements.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_OCC_HELP = {
  screenId: 'fin-occ',
  label: 'Tarjetas Propias',
  navPath: 'Finanzas → Tarjetas Propias',
  keywords: [
    'tarjeta propia', 'tarjeta corporativa', 'tarjeta empresa', 'resumen tarjeta',
    'gasto con tarjeta', 'visa corporativa', 'movimientos tarjeta',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Administrá tarjetas corporativas, consultá los consumos y armá los resúmenes mensuales. Primero cargá la tarjeta; los consumos se registran en Pagos con «tarjeta propia»; después creá el resumen del período y registrá el pago en banco o caja.',
  sidebarItems: [FIN_OCC_CARDS_ITEM, FIN_OCC_MOVEMENTS_ITEM, FIN_OCC_STATEMENTS_ITEM],
}

